import { DashboardSection } from '../../types';

import CachePanel from './panels/CachePanel';

export const cacheSection: DashboardSection = {
  key: 'cache',
  label: 'Cache',
  // CachePanel is entirely engineer-driven, so it ignores the poll interval.
  tabs: [{ key: 'keys', label: 'Keys', render: () => <CachePanel /> }]
};
